// This file is automatically generated. Do not edit manually.

import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType";
import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues";
import { IsoDateTimeString } from "src/types/dateTime";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SitePartTestConfigurationResultOperationsApi {
	export async function getTestConfigurationResultOperations(args: {
		configurationSessionId: string;
		configuratorType: PartConfiguratorType;
		propertyValues: ConfigurationPropertyValues;
	}): Promise<Array<SitePartTestConfigurationResultOperationsApi_Row>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/testing/sitePartOperations/getTestConfigurationResultOperations",
			method: "POST",
			data: {
				configurationSessionId: args.configurationSessionId,
				configuratorType: args.configuratorType,
				propertyValues: args.propertyValues,
			},
		});
		return response as Array<SitePartTestConfigurationResultOperationsApi_Row>;
	}
}

export interface SitePartTestConfigurationResultOperationsApi_Row {
	materialOperationDescription: string;
	materialOperationNo: string;
	operationDescription: string;
	operationNo: string;
	lastUpdated: IsoDateTimeString;
	materialOperationId: number | null | undefined;
	operationId: number;
	partConfigurationId: number;
	partConfigurationOperationId: number;
	position: number;
	setUpTime: number | null | undefined;
	workingTime: number | null | undefined;
}
